import React from 'react';
import { Link } from 'react-router-dom';
import heroCloud from '../assets/images/hero/hero-cloud.png';

interface PageHeroProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle: string;
  /** Breadcrumb label for the current page */
  crumb: string;
}

/** Coral banner used at the top of inner pages, styled like the homepage hero. */
const PageHero: React.FC<PageHeroProps> = ({ eyebrow, title, subtitle, crumb }) => (
  <section className="page-hero">
    <span className="page-hero-circle page-hero-circle-1" aria-hidden="true"></span>
    <span className="page-hero-circle page-hero-circle-2" aria-hidden="true"></span>
    <img className="page-hero-cloud page-hero-cloud-1" src={heroCloud} alt="" aria-hidden="true" />
    <img className="page-hero-cloud page-hero-cloud-2" src={heroCloud} alt="" aria-hidden="true" />

    <div className="container page-hero-inner">
      <nav className="page-hero-crumbs" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <i className="fas fa-chevron-right" aria-hidden="true"></i>
        <span aria-current="page">{crumb}</span>
      </nav>
      {eyebrow && <span className="page-hero-eyebrow">{eyebrow}</span>}
      <h1 className="page-hero-title">{title}</h1>
      <p className="page-hero-subtitle">{subtitle}</p>
    </div>

    <svg className="page-hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true">
      <path className="page-hero-wave-back" d="M0,40 C300,110 620,120 900,92 C1120,70 1300,40 1440,30 L1440,120 L0,120 Z" />
      <path className="page-hero-wave-front" d="M0,72 C320,130 660,130 940,108 C1160,90 1320,66 1440,58 L1440,120 L0,120 Z" />
    </svg>
  </section>
);

export default PageHero;
